import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { AntimalwareAntiTamperingPanelView } from '../view/AntimalwareAntiTamperingPanelView';
import { templateAntimalwareAntiTamperingPanel } from '../view/template';
import { AntimalwareAntiTamperingPanelRepository } from '../repository/AntimalwareAntiTamperingPanelRepository';
import { AntimalwareAntiTamperingPanelWebComponent } from '../index';
import { AntimalwareAntiTamperingPanelWebComponentSchema } from '../types';
import { RadioEvent } from '../../../ui/gzRadio/types';

export class AntimalwareAntiTamperingPanelController extends BaseWebComponentController {
  public component: AntimalwareAntiTamperingPanelWebComponent;
  public dataRepository: AntimalwareAntiTamperingPanelRepository;
  public view: AntimalwareAntiTamperingPanelView;
  public viewConstructor: typeof AntimalwareAntiTamperingPanelView;
  public dataRepositoryConstructor: typeof AntimalwareAntiTamperingPanelRepository;

  constructor(component: AntimalwareAntiTamperingPanelWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: AntimalwareAntiTamperingPanelView,
      viewTemplate: templateAntimalwareAntiTamperingPanel,
      dataRepositoryConstructor: AntimalwareAntiTamperingPanelRepository,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$antiTamperingCheckboxForm,
        event: 'change',
        callback: this.onAntiTamperingCheckboxChange,
      },
      {
        element: this.view.dom.$vulnerableDriversCheckboxForm,
        event: 'change',
        callback: this.onVulnerableDriversCheckboxChange,
      },
      {
        element: this.view.dom.$vulnerableDriversRadioGroupForm,
        event: RadioEvent.SELECTION_CHANGED,
        callback: this.onVulnerableDriversRadioGroupSelectionChange,
      },
      {
        element: this.view.dom.$callbackEvasionCheckboxForm,
        event: 'change',
        callback: this.onCallbackEvasionCheckboxChange,
      },
      {
        element: this.view.dom.$isolateEndpointCheckboxForm,
        event: 'change',
        callback: this.onIsolateEndpointCheckboxChange,
      },
      {
        element: this.view.dom.$rebootEndpointCheckboxForm,
        event: 'change',
        callback: this.onRebootEndpointCheckboxChange,
      },
      {
        element: this.view.dom.$callbackEvasionRadioGroupForm,
        event: RadioEvent.SELECTION_CHANGED,
        callback: this.onCallbackEvasionRadioGroupSelectionChange,
      },
    ];
  }

  async getDataForView(): Promise<AntimalwareAntiTamperingPanelWebComponentSchema> {
    const formValue = this.component.getFormValue();
    return { formValue } as AntimalwareAntiTamperingPanelWebComponentSchema;
  }

  private onAntiTamperingCheckboxChange(event: CustomEvent) {
    const newValue = event.detail.checked;
    this.view.setDisabledForm();
    this.component.onFormFieldChange('enabled', newValue);
  }

  private onVulnerableDriversCheckboxChange(event: CustomEvent) {
    const newValue = event.detail.checked;
    this.view.setDisabledVulnerableDrivers();
    this.component.onFormFieldChange('vulnerableDrivers.enabled', newValue);
  }

  private onVulnerableDriversRadioGroupSelectionChange(event: CustomEvent) {
    const newValue = event.detail.selectedValue;
    this.component.onFormFieldChange('vulnerableDrivers.action', newValue);
  }

  private onCallbackEvasionCheckboxChange(event: CustomEvent) {
    const newValue = event.detail.checked;
    this.view.setDisabledCallbackEvasion();
    this.component.onFormFieldChange('callbackEvasion.enabled', newValue);
  }

  private onIsolateEndpointCheckboxChange(event: CustomEvent) {
    const newValue = event.detail.checked;
    this.component.onFormFieldChange('callbackEvasion.actions.isolateEndpoint', newValue);
  }

  private onRebootEndpointCheckboxChange(event: CustomEvent) {
    const newValue = event.detail.checked;
    this.view.setDisabledRebootTimeRadioGroup();
    this.component.onFormFieldChange('callbackEvasion.actions.rebootEndpoint', newValue);
  }

  private onCallbackEvasionRadioGroupSelectionChange(event: CustomEvent) {
    const newValue = event.detail.selectedValue;
    this.component.onFormFieldChange('callbackEvasion.actions.rebootTime', newValue);
  }
}
